module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/410f44152b97ae6adf77230276c0868d.png";